import { bindActionCreators } from 'redux';

const mapActionsToDispatchToProps = (mapping) => (dispatch) => bindActionCreators(mapping ?? {}, dispatch);

export default mapActionsToDispatchToProps;
